module.exports = __webpack_public_path__ + "static/media/10.a538242f.webp";